const gridColumnMenuSelector = (state) => state.columnMenu;
export {
  gridColumnMenuSelector
};
//# sourceMappingURL=columnMenuSelector.es.js.map
